import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentService, SiteContentAbout } from '../../services/content.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-about',
  imports: [CommonModule],
  templateUrl: './about.html',
  styleUrl: './about.scss',
})
export class About implements OnInit {
  content$!: Observable<any>;

  constructor(private contentService: ContentService) {}

  ngOnInit() {
    this.content$ = this.contentService.getAboutContent();
  }

  getImgSrc(url: string | undefined): string {
    if (!url) return 'https://images.unsplash.com/photo-1549931319-a545dcf3bc73?auto=format&fit=crop&w=800&q=80';
    return url.startsWith('/uploads/') ? `https://dev.thehuskbakery.com/api${url}` : url;
  }
}
